module.exports = __webpack_public_path__ + "img/offer_blue_icon.3c8cfff9.svg";